import { AxiosPromise } from 'axios';
import { instance } from '../../../../services';

const activateBadge = (badgeNumber: string): AxiosPromise =>
  instance.put(`/api/badges/${badgeNumber}/activate`);

export default activateBadge;
